/* eslint-disable arrow-body-style */
/* LIBS */
import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
/* */
import { Mobile } from 'app/components/Responsive';
import { UIHeading } from 'app/components/ui';
import ClosePopup from 'app/components/ui/ClosePopup';
/* STYLES */
import styles from './bottomOpeningSelect.module.scss';



interface IBottomOpeningSelect {
    closeHandler: () => void,
    disabled?: boolean
    children: React.ReactNode
    headerText?: string
    transition: string
    contentText?: string | React.ReactNode
    ctx?: string,
}

const BottomOpeningSelectComponent = ({
    transition,
    headerText = '',
    children,
    closeHandler,
    disabled = false,
    contentText = '',
    ctx = 'default',
}: IBottomOpeningSelect) => {
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        const scrollTarget = scrollContainerRef.current;
        const lockedTransistions = ['entered', 'entering'];

        if (scrollTarget) {
            if (lockedTransistions.includes(transition)) {
                disableBodyScroll(scrollTarget);
            } else {
                enableBodyScroll(scrollTarget);
            }
        }

        return () => {
            if (scrollTarget) {
                enableBodyScroll(scrollTarget);
            }
        };
    }, [transition]);

    return (
        <div
            className={styles.mobileSelectMainWrapper}
            id={headerText}
        >
            <button
                className={cn(styles.mobileSelectActiveBG, styles[transition], styles[ctx])}
                onClick={closeHandler}
                type="button"
                aria-label="close select"
                disabled={disabled}
            />
            <div className={cn(styles.mobileSelectRoot, styles[transition], styles[ctx])}>
                <Mobile>
                    <div className={cn(styles.mobileSelectHeaderRow)}>
                        <div className={styles.mobileSelectHeaderRowTitle}>
                            <UIHeading level="3.2">
                                {headerText}
                            </UIHeading>
                        </div>
                        <div className={styles.mobileSelectHeaderRowCloseButton}>
                            <ClosePopup onClick={closeHandler} />
                        </div>
                    </div>
                </Mobile>

                <div
                    className={cn(styles.mobileSelectContentRow, styles[ctx])}
                    ref={scrollContainerRef}
                >
                    {contentText && (
                        <div className={styles.mobileSelectContentTitle}>
                            <UIHeading level="3.2">
                                {contentText}
                            </UIHeading>
                        </div>
                    )}
                    {children}
                </div>
            </div>
        </div>
    );
};


export const BottomOpeningSelect = React.memo(BottomOpeningSelectComponent);
